import { Col, Row, Card, Table } from 'antd';
import React from 'react';
import { driverDeductions, getColumnsWithHighlight } from '../AllOrgActivities/helper';

export const DriverDeductions = ({ data }) => {

    const renderRegularGroup = (changes, title, action) => {
      if(action === "UPDATE") return null;
    const keyName = changes?.new_value ? 'new_value' : changes?.old_value ? 'old_value' : null;
        return (
          <div className="mb-6">
            <h4
              className="ant-typography ant-typography-md font-medium mb-3"
              style={{ textAlign: "left", fontSize: "16px" }}
            >
              {title}
            </h4>
            <Card
             style={{
              background: "#fff",
              borderRadius: "8px",
              boxShadow: "0 2px 8px rgba(0,0,0,0.09)",
              marginBottom: "16px",
              padding: "2px",
            }}
            >
              <Table
                columns={driverDeductions}
                dataSource={changes[keyName] || []}
                pagination={false}
                bordered
                scroll={{ x: 'max-content', y:`calc(100vh - 600px)` }}
              />
            </Card>
          </div>
        );
    };

    const renderModifiedGroup = (changes) => {

  const oldValues = changes?.old_value
  const newValues = changes?.new_value
  if (_.isEmpty(oldValues) || _.isEmpty(newValues)) return null;
        const newColumns = getColumnsWithHighlight(driverDeductions, oldValues, newValues);

        return (
            <div className="mb-6">
                <h4 className="ant-typography ant-typography-md font-medium mb-3" style={{ textAlign: 'left', fontSize: '16px' }}>Modified Entries</h4>
                <h5 className="ant-typography ant-typography-sm font-medium mb-2" style={{ textAlign: 'left', color: '#666', fontWeight: 'bold' }}>Previous Values</h5>
                <div className="mb-4">
                    <Card
                     style={{
                      background: "#fff",
                      borderRadius: "8px",
                      boxShadow: "0 2px 8px rgba(0,0,0,0.09)",
                      marginBottom: "16px",
                      padding: "2px",
                    }}
                    >
                        <Table
                            columns={driverDeductions}
                            dataSource={oldValues}
                            pagination={false}
                            bordered
                            scroll={{ x: 'max-content', y:`calc(100vh - 600px)` }}
                        />
                    </Card>
                </div>
                <h5 className="ant-typography ant-typography-sm font-medium mb-2" style={{ textAlign: 'left', color: '#666', fontWeight: 'bold' }}>Updated Values</h5>
                <div>
                    <Card
                     style={{
                      background: "#fff",
                      borderRadius: "8px",
                      boxShadow: "0 2px 8px rgba(0,0,0,0.09)",
                      marginBottom: "16px",
                      padding: "2px",
                    }}
                    >
                        <Table
                            columns={newColumns}
                            dataSource={newValues}
                            pagination={false}
                            bordered
                            scroll={{ x: 'max-content', y:`calc(100vh - 600px)` }}
                        />
                    </Card>
                </div>
            </div>
        );
    };

    const driverDeductionsData = data?.difference[0] ? data?.difference[0] : [];
    const incomingEntry = driverDeductionsData?.new_value ? "New Entry" : "Old Entry";
    const incomingAction = data?.action

    const renderDriverDeductions = () => {
        return (
            <div className="mt-6">
                <h4 className="ant-typography ant-typography-md font-medium mb-3" style={{ textAlign: 'left', fontSize: '18px' }}>
                    <span style={{ fontSize: '20px', color: '#395484' }}>Driver Deductions</span>
                    <div className="mt-6">
                        {renderRegularGroup(driverDeductionsData, incomingEntry,incomingAction)}
                        {renderModifiedGroup(driverDeductionsData)}
                    </div>
                </h4>
            </div>
        );
    };

  return (
    <Row gutter={[16, 32]}>
        <Col span={24}>{renderDriverDeductions()}</Col>
    </Row>
  );
};